<p class="text">Page Not Found!</p>
<p class="number">404</p>
